import GridOn from '@mui/icons-material/GridOn';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { exportToCSV } from '@shared/utils/fileExport';
import { resetReport } from '@store/actions/common/fileExport/exportAction';
import FileSaver from 'file-saver';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ExportSvgIcon } from '../icons';

interface ExportReportButtonProps {
  data: any[];
  onGeneratePdf: () => void;
  label?: string;
  hideIcon?: boolean;
}

const ExportReportButton = ({
  data,
  onGeneratePdf,
  label = 'EXPORTAR',
  hideIcon = false,
}: ExportReportButtonProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const dispatch = useDispatch();
  const report = useSelector((state: any) => state.report);
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (report.data?.message == 'Report generated') {
      FileSaver.saveAs(report.data.data, 'report.pdf');
      handleClose();
    }
  });

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    dispatch(resetReport());
    setAnchorEl(null);
  };
  const handleExportCsv = () => {
    exportToCSV(data, 'report', '.csv');
    handleClose();
  };
  const handleExportPdf = async () => {
    onGeneratePdf();
  };

  const exportMenu = (
    <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
      <MenuItem onClick={handleExportPdf} disabled={report.loading}>
        <ListItemIcon>
          <PictureAsPdfIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Como PDF</ListItemText>
      </MenuItem>
      <MenuItem onClick={handleExportCsv}>
        <ListItemIcon>
          <GridOn fontSize="small" />
        </ListItemIcon>
        <ListItemText>Como Excel</ListItemText>
      </MenuItem>
    </Menu>
  );
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={hideIcon ? undefined : <ExportSvgIcon />}
        onClick={handleClick}
        className="export-button"
        disabled={report.loading || !data || data.length === 0}>
        {label}
      </Button>
      {exportMenu}
    </>
  );
};

export default ExportReportButton;
